import type { StoreState } from '@deqo/foundation';
import { memone, VoidCallback } from '@deqo/foundation';
import { injectable } from 'inversify';
import { resolve } from '../Container';
import { PassportModel, PermissionSet } from '../PassportModel';
import { StateProperty, StatePropertyRef } from './ExtendableStore';

export interface MyRoleInfo {
    canManage?: boolean;
    canDesign?: boolean;
    canParticipate?: boolean;
}

export const MyRoleInfo = StatePropertyRef<MyRoleInfo>('permissions', {});

@injectable()
export class MyRoleInfoProperty implements StateProperty<MyRoleInfo> {

    @resolve(PassportModel) private passport: PassportModel;

    public readonly name = MyRoleInfo.name;
    public readonly writable = false;

    public get(): MyRoleInfo {
        return this.toValue(this.passport.getState());
    }

    public watch(callback: VoidCallback): VoidCallback {
        return this.passport.observe(() => callback());
    }

    @memone()
    private toValue(state: StoreState<PassportModel>) {
        const ps = new PermissionSet(state);
        const canManage = ps.verify('bo:write', 'bo:facilitate');
        const canDesign = ps.verify('da:write');
        const canParticipate = ps.verify('bo:write');
        return { canManage, canDesign, canParticipate };
    }
}
